/* eslint-disable import/no-cycle */
import API from './api';
import { normalizarEscopoAmbiente } from './escopoAmbiente';

export const getEscopoUsuario = params =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/escopo-usuario`, params);

export const getLogin = params => API.post(`${process.env.REACT_APP_LOGIN}/login`, params);

export const getEscopoAmbiente = () =>
  API.get(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/escopo-ambiente`).then(response => ({
    ...response,
    data: normalizarEscopoAmbiente(response.data)
  }));

export const getDepartamentos = () =>
  API.get(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/listar-departamentos`);

export const getMenus = codDepartamento =>
  API.get(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/listar-menus/${codDepartamento}`);

export const getDadosPessoaisUsuario = () =>
  API.get(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/listar-dados-pessoais`);

export const getInformacoesSaldo = () =>
  API.get(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/listar-informacoes-saldo`);

export const deletarTelaFavoritada = codSubmenu =>
  API.delete(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/deletar-favorito`, {
    data: {
      CODSUBMENU: codSubmenu
    }
  });

export const criarFavorito = codSubmenu =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/criar-favorito`, {
    CODSUBMENU: codSubmenu
  });
export const listarFavoritos = filtro =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/listar-favorito`, {
    FILTRO: filtro
  });

export const alterarFavoritoFixado = params =>
  API.put(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/alterar-favorito-fixado`, params);

export const filtrarMenus = filtro =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/filtrar-menus`, {
    FILTRO: filtro
  });

export const criarFeedback = ({ descricao, aceitaEntrarEmContato }) =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/feedback-usuario`, {
    DESCRICAO: descricao,
    ACEITAENTRAREMCONTATO: aceitaEntrarEmContato
  });

export const verificaLoginUsuario = values =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/authentication/login`, values);

export const reenviaTokenConfirmacao = email =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/authentication/reenvia-token`, {
    email: email
  });

export const confirmacaoResend = values =>
  API.post(
    `${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/authentication/confirmacao-resend`,
    values
  );

export const confirmacaoSalvar = values =>
  API.post(
    `${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/authentication/confirmacao-salvar`,
    values
  );

export const resetPassword = (params, token) =>
  API.post(
    `${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/authentication/nova-senha/${token}`,
    params
  );

export const recoveryPassword = forgotPassword =>
  API.post(
    `${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/authentication/recuperar-senha`,
    forgotPassword
  );

export const salvarAcesso = ({ codModulo, codTela, codusuario, nomeUsuario }) =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/filas/registrar-acesso`, {
    codModulo: codModulo,
    codTela: codTela,
    codUsuario: codusuario,
    nome: nomeUsuario
  });

export const getValorOperado = (params, codCliente = 'todos') =>
  API.post(`${process.env.REACT_APP_API_HUB}/operacao/v1/operacoes/listar-vop-meta`, params, {
    headers: {
      'X-One7-Codcliente': codCliente
    }
  });

export const getEmpresasDashboardFinanceiro = () =>
  API.get(`${process.env.REACT_APP_API_HUB}/financeiro/v1/remessas/empresas`, {}).then(response => ({
    ...response,
    data: response?.data?.data ?? []
  }));

export const getBoletosPendentesFinanceiro = cpfcnpjTitular =>
  API.post(`${process.env.REACT_APP_API_HUB}/financeiro/v1/remessa-banco/boletos-pendentes`, {
    cpfcnpj_titular: cpfcnpjTitular
  }).then(response => ({
    ...response,
    data: response?.data?.data ?? response?.data ?? {}
  }));

export const getInstrucoesPendentesFinanceiro = params =>
  API.post(
    `${process.env.REACT_APP_API_HUB}/financeiro/v1/remessa-banco/instrucoes-pendentes`,
    params
  ).then(response => ({
    ...response,
    data: response?.data?.data ?? response?.data ?? {}
  }));

export const getRemessasPendentesFinanceiro = params =>
  API.post(
    `${process.env.REACT_APP_API_HUB}/financeiro/v1/remessa-banco/remessas-pendentes`,
    params
  ).then(response => ({
    ...response,
    data: response?.data?.data ?? response?.data ?? {}
  }));

export const getBancosAgenciasFinanceiro = codEmpresa =>
  API.get(`${process.env.REACT_APP_API_HUB}/financeiro/v1/remessas/bancos-agencias`, {
    params: {
      codEmpresa: codEmpresa
    }
  }).then(response => ({
    ...response,
    data: response?.data?.data ?? []
  }));

export const getTitulosPendencias = (params, codCliente = 'todos') =>
  API.post(`${process.env.REACT_APP_API_HUB}/operacao/v1/operacoes/listar-titulos-pendencias`, params, {
    headers: {
      'X-One7-Codcliente': codCliente
    }
  });

export const getListaInformacoesIniciais = (codCliente = 'todos') =>
  API.get(`${process.env.REACT_APP_API_SLIM_BASE_URL}/area-cliente/dash-lista-plataformas`, {
    headers: {
      'X-One7-Codcliente': codCliente
    }
  });
